const API_URL = process.env.REACT_APP_API_URL || 'https://polumesa-iek-eksaskisi.online/api';

/**
 * Upload avatar to server
 * @param {string} base64Image - Base64 encoded image
 * @returns {Promise<Object>} Response with success status and avatar URL
 */
export const uploadAvatar = async (base64Image) => {
  try {
    const token = localStorage.getItem('authToken');
    
    if (!token) {
      throw new Error('No authentication token found');
    }

    console.log('Uploading avatar to:', `${API_URL}/avatar/upload`);
    console.log('Token:', token ? 'Present' : 'Missing');

    const response = await fetch(`${API_URL}/avatar/upload`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        avatar: base64Image
      })
    });

    console.log('Response status:', response.status);
    
    const data = await response.json();
    console.log('Response data:', data);
    
    if (!response.ok) {
      throw new Error(data.message || `Upload failed with status ${response.status}`);
    }

    return data;
  } catch (error) {
    console.error('Avatar upload error:', error);
    throw error;
  }
};

/**
 * Get avatar URL for a user
 * @param {string} username - Username
 * @returns {string} Avatar URL
 */
export const getAvatarUrl = (username) => {
  return `${API_URL}/avatar/${username}`;
};

/**
 * Delete avatar from server
 * @returns {Promise<Object>} Response with success status
 */
export const deleteAvatar = async () => {
  try {
    const token = localStorage.getItem('authToken');
    
    if (!token) {
      throw new Error('No authentication token found');
    }

    const response = await fetch(`${API_URL}/avatar`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Delete failed');
    }

    return data;
  } catch (error) {
    console.error('Avatar delete error:', error);
    throw error;
  }
};

/**
 * Load avatar from server or localStorage
 * @param {string} username - Username
 * @returns {Promise<string|null>} Base64 image or null
 */
export const loadAvatar = async (username) => {
  try {
    // First check localStorage
    const localAvatar = localStorage.getItem(`avatar_${username}`);
    if (localAvatar) {
      return localAvatar;
    }

    // Try to fetch from server
    const avatarUrl = getAvatarUrl(username);
    const response = await fetch(avatarUrl);
    
    if (response.ok) {
      const blob = await response.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    }
    
    return null;
  } catch (error) {
    console.error('Avatar load error:', error);
    return null;
  }
};
